import { useQuery } from '@tanstack/react-query';
import { TError, TTeacherDirectory } from '@onesource/schemas';
import axios from '../axios';
import { TEACHER_DIRECTORY_PATH } from './entity';

export const getTeacherDirectoryQueryKey = () => ['teacher-directory'];

type TParams = {
  enabled?: boolean;
};

// Lazy: teacher_directory is intentionally separate from useGetAllProfileQuery and
// is NOT merged into the global profile cache. Only call this hook from pages
// that actually need teacher info (e.g. the Teacher's Directory tab).
export const useGetTeacherDirectoryQuery = (params?: TParams) => {
  const enabled = params?.enabled ?? true;

  return useQuery<TTeacherDirectory | null, TError>({
    queryKey: getTeacherDirectoryQueryKey(),
    queryFn: async () => {
      const res = await axios.get<TTeacherDirectory | null>(`/${TEACHER_DIRECTORY_PATH}`);
      return res.data ?? null;
    },
    enabled,
    staleTime: Infinity,
    gcTime: Infinity,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
};

export type TUseGetTeacherDirectoryQueryResult = ReturnType<typeof useGetTeacherDirectoryQuery>;
